<template>
  <el-dialog
      v-model="visible"
      title="选择列表显示数据"
      width="600px"
      append-to-body
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
    <el-checkbox-group v-model="columnCheckList" class="columnSet">
      <draggable
        :list="localFields"
        :itemKey="getColIdentity"
        ghost-class="ghost"
        chosen-class="chosenClass"
        animation="300">
        <template #item="{ element }">
          <el-checkbox :value="getColIdentity(element)" :label="element.fieldName" />
        </template>
      </draggable>
    </el-checkbox-group>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleResetColumn">恢复默认</el-button>
        <el-button @click="handleClose" type="danger" >取消</el-button>
        <el-button type="primary" @click="handleSetColumn" >确定</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>
<script lang='ts'>
import { defineComponent, reactive, toRefs, PropType, watch } from 'vue'
import { ElMessage } from 'element-plus'
import { TableFieldModel } from '@/model/TableList'
import { tableSetting } from '@/apis/tool'
import draggable from 'vuedraggable'

export default defineComponent({
  name: 'CustomColumn',
  components: {
    draggable
  },
  props: {
    visible: { type: Boolean, required: false, default: true },
    tabelField: { type: Array as PropType<Array<TableFieldModel>>, required: true },
    tableName: { type: String, required: true },
    checkList: { type: Array, required: true, default: () => [] }
  },
  emits: ['update:visible', 'submit'],
  setup(props, context) {
    const getColIdentity = (col: any): string => `${col?.fieldKey ?? ''}__${col?.fieldName ?? ''}`
    const refs = reactive({
      localFields: props.tabelField.map((item: any) => ({ ...item })),
      columnCheckList: (props.checkList && props.checkList.length)
        ? props.checkList.map((item: any) => typeof item === 'object' ? getColIdentity(item) : (props.tabelField.find((f: any) => f.fieldName === item || f.fieldKey === item) ? getColIdentity(props.tabelField.find((f: any) => f.fieldName === item || f.fieldKey === item)) : item))
        : props.tabelField.filter((item: any) => item.isCheck !== false).map((item: any) => getColIdentity(item)),
      getColIdentity,

      handleClose() {
        context.emit('update:visible')
      },
      handleSetColumn() {
        if (!refs.columnCheckList.length) {
          ElMessage.error('必须选择一项！')
          return
        }
        const tempArr = refs.localFields.map((item: any) => ({
          ...item,
          isCheck: refs.columnCheckList.includes(getColIdentity(item)) || refs.columnCheckList.includes(item.fieldName)
        }))
        tableSetting({
          tableName: props.tableName,
          fields: tempArr
        }).then(() => {
          refs.handleClose()
          ElMessage.success('设置成功！')
          context.emit('submit')
        }).catch(() => {
          ElMessage.error('设置失败！')
        })
      },
      handleResetColumn() {
        const defaultFields = props.tabelField.map((item: any) => ({
          ...item,
          isCheck: true,
          width: item.width
        }))
        tableSetting({
          tableName: props.tableName,
          fields: defaultFields
        }).then(() => {
          refs.handleClose()
          ElMessage.success('已恢复默认列设置！')
          context.emit('submit')
        }).catch(() => {
          ElMessage.error('恢复默认失败！')
        })
      }
    })
    watch(() => props.tabelField, (val) => {
      refs.localFields = (val || []).map((item: any) => ({ ...item }))
    })
    return { ...toRefs(refs) }
  }

})
</script>
<style lang="scss">
.columnSet{
  .el-checkbox{
    // width: 124px;
    margin-right: 20px;
    margin-bottom: 16px;
  }
}
</style>
